import React, { useState } from 'react';
import { colors, H3, P14, P16 } from 'client/v3/typography';
import PaymentFormFields from '@ff/ui/Form2/presets/PaymentForm';
import CheckBoxField from '@ff/ui/Form2/Fields/CheckBoxField';
import ButtonWithErrorBox from '@ff/ui/Form2/ButtonWithErrorBox';
import { styled } from '@ff/ui';
import Currency from 'client/v3/components/Currency';
import Link from '@ff/ui/Link';
import IFrameModal from '@ff/ui/Modal/presets/IFrameModal';
import PATHS from 'client/utils/paths';
import Box from '@ff/ui/Box';
import url from 'client/utils/url';
import ContainerWithPadding from '../ContainerWithPadding';
import ButtonContainer from './ButtonContainer';
import ReferralCodeBox from './ReferralCodeBox';
import useConfig from 'client/hooks/useConfig';

export default function PaymentForm({ dueAmount, newOrder }) {
  const [openOrderAgreement, setOpenOrderAgreement] = useState(false);
  const { ORDER: orderNum, VEH: modelCode } = useConfig();

  return (
    <>
      <ContainerWithPadding>
        <H3 mt='94px' mb='30px'>Billing Information:</H3>
        <PaymentFormFields />
        <Divider />
        { !orderNum && (
          <Row mt='32px'>
            <ReferralCodeBox modelCode={modelCode}/>
          </Row>
        )}
        <Row mt='32px'>
          <P16 fontWeight={450}>Due Today</P16>
          <P16 fontWeight={450}><Currency>{dueAmount}</Currency></P16>
        </Row>
        <Box mt='32px'>
          <CheckBoxField
            name='orderAgreement'
            required
            label={
              <P14 fontWeight={400}>
                {`By submitting this order, I agree to the `}
                <Link
                  textDecoration='underline'
                  onClick={() => setOpenOrderAgreement(true)}
                >
                  FF Preorder Agreement
                </Link>
              </P14>
            }
          />
        </Box>
      </ContainerWithPadding>
      <ButtonContainer>
        <ButtonWithErrorBox
          name='payment'
          fullWidth
          variant='dark'
        >
          {newOrder ? 'Place Preorder' : 'Payment & Update Preorder'}
        </ButtonWithErrorBox>
      </ButtonContainer>
      <IFrameModal
        closeIcon
        styleProps={{ width: '85vw', height: '85vh' }}
        link={`${url.getSameRegionPath(PATHS.PREORDER_AGREEMENT)}/?APPONLY=1`}
        open={openOrderAgreement}
        onClose={() => setOpenOrderAgreement(false)}
      />
    </>
  )
}

const Row = styled.Box({
  display: 'flex',
  justifyContent: 'space-between'
});

const Divider = styled(Box)({
  marginTop: '16px',
  borderTop: colors.border3,
});
